import { FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { Api } from '../lib/apiClient'

export function LoginForm({ onSuccess }: { onSuccess?: () => void }) {
	const { login } = useAuth()
	const navigate = useNavigate()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState<string | null>(null)

	const onSubmit = async (e: FormEvent) => {
		e.preventDefault()
		setError(null)
		try {
			console.log('Starting login with API client')
			const data = await Api.login({ email, password })
			console.log('Login successful:', data)
			
			// Validate response data
			if (!data.token || !data.user) {
				console.error('Invalid login response - missing token or user:', data)
				throw new Error('Invalid response from server')
			}
			
			if (!data.user.email || !data.user.name || !data.user.id) {
				console.error('Invalid user data in response:', data.user)
				throw new Error('Invalid user data received')
			}
			
			// Login the user immediately
			console.log('Attempting to login user:', data.user)
			try {
				login(data.token, data.user)
			} catch (loginError) {
				console.error('Login failed:', loginError)
				const errorMessage = loginError instanceof Error ? loginError.message : 'Unknown login error'
				throw new Error('Failed to log in: ' + errorMessage)
			}
			
			// Close modal first
			onSuccess?.()
			
			// Navigate based on user role and current location
			setTimeout(() => {
				const currentPath = window.location.pathname
				const isAdminUser = data.user.role === 'admin' || 
					['admin@date-shake.com', 'nrmokh@gmail.com'].includes(data.user.email?.toLowerCase())
				
				console.log('🔍 Login redirect logic:', { currentPath, isAdminUser, userRole: data.user.role })
				
				// If we're in admin portal and user is admin, stay in admin portal
				if (currentPath.startsWith('/admin') && isAdminUser) {
					console.log('✅ Staying in admin portal')
					navigate('/admin')
				} else if (isAdminUser) {
					console.log('✅ Admin user - going to admin portal')
					navigate('/admin')
				} else {
					console.log('✅ Regular user - going to dashboard')
					navigate('/dashboard')
				}
			}, 200)
		} catch (err: any) {
			console.error('Login error:', err)
			setError(err.message)
		}
	}

	return (
		<form className="space-y-3" onSubmit={onSubmit}>
			{error && <div className="text-red-600 text-sm">{error}</div>}
			<input className="w-full border p-2 rounded" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
			<input className="w-full border p-2 rounded" placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} />
			<button type="submit" className="btn-primary w-full">Sign In</button>
		</form>
	)
}

export default function Login() {
	return (
		<section className="max-w-md mx-auto px-4">
			<h1 className="text-2xl font-semibold text-black">Login</h1>
			<div className="mt-4">
				<LoginForm />
			</div>
		</section>
	)
}
